export default "__VITE_ASSET__DUltvxkQ__"